import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-features-stye-three',
  templateUrl: './features-stye-three.component.html',
  styleUrls: ['./features-stye-three.component.scss']
})
export class FeaturesStyeThreeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
